<template>
  <v-container grid-list-md  v-if="stellen">
    <v-layout
      row
      wrap
      v-if="stellen.length > 0"
    >
      <v-flex
        xs12
        lg10
        offset-lg1
        xl8
        offset-xl2
      >

        <h3 class="display-1 mt-3">
          Job- & Ausbildungsangebote im Innungshandwerk
        </h3>
          <p class="subheading my-3">
            Die Nachwuchsförderung ist ein wichtiges Thema für Innungsbetriebe.
          Wir bieten die Möglichkeit, Ausbildungen, Praktika oder Jobangebote im organisierten Handwerk zu finden. 
          </p>
        <div
          v-if="isLoading"
          class="text-xs-center my-5"
        >
          <v-progress-circular
            indeterminate
            color="secondary"
            :size="50"
          ></v-progress-circular>
        </div>
        
        <div
          class="mt-3"
          v-if="stellen"
        >
          <v-toolbar
            class="mt-4"
            flat
          >
            <v-toolbar-title>Beschreibung</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-title class="text-xs-right">Bewerbungsfrist</v-toolbar-title>
          </v-toolbar>
          <stellen-liste
            :stellen="stellen"
            :startseite="true"
            v-if="stellen.length > 0"
            key="startseite"
          ></stellen-liste>
          
            <v-layout v-else>
             <v-flex xs12 class="text-xs-center mt-3">
                <v-btn
                  large
                  color="secondary"
                  class="title text-none"
                  :to="{ name: 'stellen' }"
                  
                >
                  <v-icon
                    left
                    dark
                  >list_alt</v-icon>
                Alle Stellen
                </v-btn>
            </v-flex>
            </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import StellenListe from '~/components/stellen/StellenListe.vue'

export default {
  data: () => ({
    stellen: null,
    busy: false,
    isLoading: true
  }),
  components: {
    StellenListe
  },
  computed: {
  },
  mounted () {
    this.getStellen()
  },
  methods: {
    getStellen: function () {
      this.isLoading = true
      var typid = 0
      if (this.typ) {
        typid = this.typ.id
      }
      const app = this
      axios
        .get('/api/v1/stellen', {
          params: {
            typ: typid,
            limit: 3
          }
        })
        .then(function (resp) {
          app.stellen = resp.data
          app.busy = false
          // console.log(resp.data)
        })
        .catch(function (error) {
          console.log('Keine Stellen vorhanden:')
          console.log(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
<style>
</style>